{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1, 2, 3]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube.001",
			"scale": [1.2965043783187866, 0.8784183263778687, 2.1594858169555664],
			"translation": [0, 0.7554872035980225, 0]
		},
		{
			"mesh": 1,
			"name": "Cylinder",
			"rotation": [0.7071068286895752, 0, 0, 0.7071068286895752],
			"scale": [0.15616469085216522, 0.15616469085216522, 0.15616469085216522],
			"translation": [-0.9904570579528809, 1.779016137123108, -1.4974032640457153]
		},
		{
			"mesh": 2,
			"name": "Cylinder.001",
			"rotation": [0.7071068286895752, 0, 0, 0.7071068286895752],
			"scale": [0.15616469085216522, 0.15616469085216522, 0.15616469085216522],
			"translation": [-0.6768726706504822, 1.779016137123108, -1.4974032640457153]
		},
		{
			"mesh": 3,
			"name": "Cylinder.002",
			"rotation": [0.7071068286895752, 0, 0, 0.7071068286895752],
			"scale": [0.15616469085216522, 0.15616469085216522, 0.15616469085216522],
			"translation": [-0.8331876397132874, 2.04375958442688, -1.4974032640457153]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.002",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.17434608936309814, 0.10012035071849823, 0.03383882716298103, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.007",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.5394041538238525, 0.39589375257492065, 0.15970169007778168, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.008",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.019548717886209488, 0.12249854952096939, 0.1649770587682724, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.6929134130477905
			}
		}
	],
	"meshes": [
		{
			"name": "Cube.005",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				},
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 2
				}
			]
		},
		{
			"name": "Cylinder",
			"primitives": [
				{
					"attributes": {
						"POSITION": 12,
						"NORMAL": 13,
						"TEXCOORD_0": 14
					},
					"indices": 15,
					"material": 2
				}
			]
		},
		{
			"name": "Cylinder.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 16,
						"NORMAL": 17,
						"TEXCOORD_0": 18
					},
					"indices": 15,
					"material": 2
				}
			]
		},
		{
			"name": "Cylinder.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 19,
						"NORMAL": 20,
						"TEXCOORD_0": 21
					},
					"indices": 15,
					"material": 2
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 269,
			"max": [1, 1.0200577974319458, 1.1171751022338867],
			"min": [-1.027970314025879, -1.3168052434921265, -1.1087663173675537],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 269,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 269,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 636,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 84,
			"max": [0.5, 1.0200577974319458, 1.0148742198944092],
			"min": [0, 0.037432849407196045, -1.0066026449203491],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 84,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 84,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 180,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 131,
			"max": [1.0404061079025269, 1.0640158653259277, 0.5],
			"min": [-1.027970314025879, -0.28179216384887695, -0.5],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 131,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 131,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 408,
			"type": "SCALAR"
		},
		{
			"bufferView": 12,
			"componentType": 5126,
			"count": 448,
			"max": [1, 1.3075549602508545, 1],
			"min": [-1, -1.9487766027450562, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 13,
			"componentType": 5126,
			"count": 448,
			"type": "VEC3"
		},
		{
			"bufferView": 14,
			"componentType": 5126,
			"count": 448,
			"type": "VEC2"
		},
		{
			"bufferView": 15,
			"componentType": 5123,
			"count": 756,
			"type": "SCALAR"
		},
		{
			"bufferView": 16,
			"componentType": 5126,
			"count": 448,
			"max": [1, 1.3075549602508545, 1],
			"min": [-1, -1.9487766027450562, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 17,
			"componentType": 5126,
			"count": 448,
			"type": "VEC3"
		},
		{
			"bufferView": 18,
			"componentType": 5126,
			"count": 448,
			"type": "VEC2"
		},
		{
			"bufferView": 19,
			"componentType": 5126,
			"count": 448,
			"max": [1, 1.3075549602508545, 1],
			"min": [-1, -1.9487766027450562, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 20,
			"componentType": 5126,
			"count": 448,
			"type": "VEC3"
		},
		{
			"bufferView": 21,
			"componentType": 5126,
			"count": 448,
			"type": "VEC2"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 3228,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 3228,
			"byteOffset": 3228,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2152,
			"byteOffset": 6456,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1272,
			"byteOffset": 8608,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 1008,
			"byteOffset": 9880,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1008,
			"byteOffset": 10888,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 672,
			"byteOffset": 11896,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 360,
			"byteOffset": 12568,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 1572,
			"byteOffset": 12928,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1572,
			"byteOffset": 14500,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1048,
			"byteOffset": 16072,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 816,
			"byteOffset": 17120,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 5376,
			"byteOffset": 17936,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 5376,
			"byteOffset": 23312,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 3584,
			"byteOffset": 28688,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1512,
			"byteOffset": 32272,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 5376,
			"byteOffset": 33784,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 5376,
			"byteOffset": 39160,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 3584,
			"byteOffset": 44536,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 5376,
			"byteOffset": 48120,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 5376,
			"byteOffset": 53496,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 3584,
			"byteOffset": 58872,
			"target": 34962
		}
	],
	"buffers": [
		{
			"byteLength": 62456,
			"uri": "work%20station.bin"
		}
	]
}
